'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const RatingText = ({
  ratingText,
  ratingNumber,
  selectedRating,
  isLandscape = false,
  feedbackRatingSubcaption = ''
}) => {
  const {
    bodytextDefaultNone: textStyle
  } = nthHookTheme.useTheme();
  let text = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "\xA0");
  if (ratingNumber > 0) {
    const ratingTextValue = ratingText[ratingNumber - 1];
    text = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, isLandscape || !selectedRating ? ratingTextValue : `${feedbackRatingSubcaption} ${ratingTextValue.toLowerCase()}?`);
  }
  return /*#__PURE__*/React__default["default"].createElement("span", {
    "data-test": "starRatingTextSmallHeader",
    style: textStyle
  }, text);
};
var RatingText$1 = nthHookTheme.withThemeProvider(RatingText, {
  themeTokens: ['bodytextDefaultNone']
});

exports["default"] = RatingText$1;
